import React, { useState, useEffect } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Button, FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import { uploadFile, getDivisions, deleteFees } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faUsers, faEdit, faBan, faSave, faTrashAlt, faPhone, faUser } from '@fortawesome/free-solid-svg-icons';
import YesNoModal from '../YesNoModal';

function ClearFees(props) {
    const today = new Date();
    const fiscalDate = new Date(today.setMonth(today.getMonth() + 9));
    const curFiscalYear = fiscalDate.getFullYear();
    const [divisionId, setDivisionId] = useState(2);
    const [divisions, setDivisions] = useState([]);
    const [fiscalYear, setFiscalYear] = useState(curFiscalYear);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);
    const [isClearingFees, setIsClearingFees] = useState(false);
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);
    const [results, setResults] = useState(null);

    useEffect(() => {
        fetchDivisions();
    }, []);

    const fetchDivisions = async () => {
        setIsLoadingDivisions(true);

        const divisionsResult = await getDivisions();
        setDivisions(divisionsResult);

        setIsLoadingDivisions(false);
    };

    const clearFees = async () => {
        try {
            setResults(null);
            setIsClearingFees(true);

            const clearOptions = {
                divisionID: divisionId,
                fiscalYear: fiscalYear
            };

            const result = await deleteFees(clearOptions);
            console.log(clearOptions);
            console.log(divisions);
            setResults({ success: true, message: `Cleared ${result.length} fiscal year ${clearOptions.fiscalYear} ${divisions?.find(d => d.divisionID === clearOptions.divisionID)?.divisionName} fees.`})
        } catch (ex) {
            if (ex.status === 404) {
                setResults({ success: false, message: "No fees found." });
            } else {
                setResults({ success: false, message: "Failed to clear fees." });
                console.log(ex);
            }
        } finally {
            setIsClearingFees(false);
        }
    };

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    let resultsJSX = null;
    if (results) {
        if (results.success) {
            resultsJSX = (
                <div className="import-results success">
                    <span>{results.message}</span>
                </div>
            );
        } else {
            resultsJSX = (
                <div className="import-results failure">
                    <span>{results.message}</span>
                </div>
            );
        }
    }

    return (
        <div id="clearFees" className="import-content">
            <div className="import-inputs">
                <FormGroup>
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faUsers}/></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" name="divisionId" value={divisionId} onChange={(e) => setDivisionId(+e.target.value)}>
                            {divisions.map(d => (<option value={d.divisionID} key={d.divisionID}>{d.divisionName}</option>))}
                        </Input>
                        <div className="tooltip-target tooltip-top">
                            DANR Program
                        </div>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faCalendar} /></InputGroupText>
                        </InputGroupAddon>
                        <Input type="number" name="fiscalYear" value={fiscalYear || ''} onChange={(e) => setFiscalYear(+e.target.value)} />
                        <div className="tooltip-target tooltip-top">
                            Fiscal Year
                        </div>
                    </InputGroup>
                </FormGroup>
            </div>
            <div className="import-buttons">
                <Button className="btn-block btn-icon" color="danr-green" onClick={toggleDeletionConfirmationModal} disabled={isClearingFees}><FontAwesomeIcon icon={faTrashAlt}/><span>Clear Fees</span></Button>
            </div>
            {resultsJSX}
            {isClearingFees ? (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>) : null}
            <YesNoModal title="Confirm Clear" yesClick={clearFees} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want clear {fiscalYear} {divisions?.find(d => d.divisionID === divisionId)?.divisionName} fees?</YesNoModal>
        </div>
    );
}

export default ClearFees;